
































import IndexTabs from '@/components/IndexTabs/index.vue';
import IntelligentIdentificationInfoDialog from '@/components/IntelligentIdentification/IntelligentIdentificationInfoDialog.vue'
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';
import { getAllYearsApi } from '@/api/index';
import { TagsViewModule } from '@/store/modules/tags-view'

@Component({
  components: {
    IndexTabs,
    IntelligentIdentificationInfoDialog
  },
  name: 'AppMain',
})
export default class extends Vue {

  get cachedViews() {
    return TagsViewModule.cachedViews
  }

  get key() {
    return this.$route.path;
  }

  get language() {
    return AppModule.language;
  }

  get showTabs() {
    return UserModule.showIndexTabs;
  }

  get agentId() {
    return Number(UserModule.fkAgentId);
  }

  public dialogVisible = false;
  public yearOptions: any = [];
  public year = UserModule.indexSelectYear;

  public created() {
    this.getAllYears();
  }

  public async getAllYears() {
    const { data } = await getAllYearsApi();
    this.yearOptions = data.data;
  }

  public handleChangeYear(year: string) {
    UserModule.SET_INDEX_SELECT_YEAR(year);
  }

  public addStudent() {
    this.dialogVisible = true;
  }

  public addApplication() {
    const stuid = this.$route.params.id + '';
    const stu = this.$route.query.stu + '';
    this.$router.push({name: 'studentApplicationForm', params: { stuid }, query: { agid: this.agentId + '', stu }});
  }

  public changeIndexTab(tabName: any) {
    this.$router.push({ name: tabName });
  }

  public handleRegister() {
    this.$router.push({ name: 'studentRegister' });
  }
}
